<!-- 微信通知自动换绑手机号页面 -->
<template>
  <div class="content">
    <aside class="aside_1">
      <div class="title">
        <h1>关注公众号-微信通知服务</h1>
        <p>会员卡余额变动推送微信提醒</p>
        <!-- <p>每日通知上限为10万次</p> -->
        <p>长按识别下方二维码关注公众号</p>
        <div class="inp-box">
          <img
            src="../image/index.png"
            alt=""
            srcset=""
            style="width: 200px; height: 200px"
          />
          <!-- <input
                    oninput="if(value.length>11)value=value.slice(0,11)"
                    placeholder="请输入您的手机号绑定"
                    style="
                      border: 1px solid red;
                      color: red;
                      font-size: 18px;
                      width: 190px;
                      height: 50px;
                      padding: 0 10px;
                    "
                    v-model="phone"
                    clear
                  />
                  <br />
                  <button @click="inputBtn" class="button">前往关注</button>-->
        </div>
      </div>
    </aside>
    <!-- <button @click="goBack" class="back-button">返回</button> -->
    <footer>
      <div>
        © 上海致善阔贤科技有限公司｜沪ICP备2022008612号-1 <br />Copyright © 2024
        shzskx.cn All Rights Reserved.
      </div>
    </footer>
  </div>
</template>

<script>
// import wx from "@/assets/js/jweixin-1.3.2.js";
// import { login, setPhone, selectPhone } from "@/services/login.js";
// import { Dialog, Toast } from "vant";
import { Toast } from "vant";
import { useWxCode } from "@/services/login.js";
import { setPhone } from "@/services/login.js";
window.addEventListener("pageshow", function(e) {
  // 通过persisted属性判断是否存在 BF Cache
  if (e.persisted) {
    location.reload();
  }
});
export default {
  data() {
    return {
      userInfo: {},
      phone: "",
      show: false,
    };
  },
  async created() {
    /* 查询用户信息 */
    let userInfo = await useWxCode();
    if (userInfo?.code === 200) {
      this.userInfo = userInfo.data;
      this.phone = userInfo.data?.phone;
       Toast("长按二维码识别关注公众号");
      // this.inputBtn();
    }

   
    // const isLogin = await selectPhone({ phone });

    // if (isLogin?.code !== 200) {
    //   Toast("长按二维码识别关注公众号");
    //   return;
    // }

  },

  methods: {
    goBack() {
      // eslint-disable-next-line no-undef
      wx.miniProgram.navigateBack(); //返回小程序上一个页面
    },
    getUrlParams(url) {
      // 通过 ? 分割获取后面的参数字符串
      let urlStr = url.split("?")[1];
      // 创建空对象存储参数
      let obj = {};
      // 再通过 & 将每一个参数单独分割出来
      let paramsArr = urlStr?.split("&") || [];
      for (let i = 0, len = paramsArr.length; i < len; i++) {
        // 再通过 = 将每一个参数分割为 key:value 的形式
        let arr = paramsArr[i].split("=");
        obj[arr[0]] = arr[1];
      }
      return obj;
    },

    /* 存入openid和手机号 */
    async inputBtn() {
      // window.location.href = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg5ODc1ODQ2MQ==#wechat_redirect"; //测试
      // // 手机号认证
      if (this.phone == "") {
        Toast("手机号不能为空");
      } else {
        const reg = /^1[2|3|4|5|6|7|8|9][0-9]\d{8}$/;
        if (reg.test(this.phone)) {
          // 发送请求
          const result = await setPhone({
            ...this.userInfo,
            phone: this.phone,
          });
          console.log("绑定手机号结果=========", result);
          //   if (result.code == 200) {
          //     // Toast("绑定成功");
          //     Dialog.confirm({
          //       title: "绑定成功",
          //       message: res.msg,
          //       theme: "round-button",
          //       showCancelButton: false,
          //     });
          //   } else {
          //     Dialog.confirm({
          //       title: "绑定失败",
          //       message: res.msg,
          //       theme: "round-button",
          //       showCancelButton: false,
          //     });
          //   }
        } else {
          Toast("手机号授权失败");
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  margin: 0 auto;
  max-width: 1920px;
}

.aside_1 {
  width: 100%;
  min-height: 360px; // border: 1px solid red;
  overflow: hidden;
  .title {
    position: relative;
    top: 24%;
    font-size: 20px;
    line-height: 30px; // border: 1px solid red;
    width: 90%;
    margin: 0 auto;
    h1 {
      font-size: 24px;
      color: #ff3e4f;
      font-weight: 700;
      line-height: 60px;
      letter-spacing: 2px;
    }
    p {
      color: #545454;
      font-size: 22px; // margin-bottom: 10px
    }
  }
  .inp-box {
    margin-top: 40px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
  }
  .button {
    background: #ff3e4f;
    color: #fff;
    padding: 0 20px;
    border: none;
    font-size: 15px;
    margin: 20px;
    height: 50px;
    border-radius: 10px;
  }
  button:hover {
    cursor: pointer;
  }
}

.back-button {
  display: block;
  width: 80%;
  background: #ff3e4f;
  color: #fff;
  padding: 0 20px;
  border: none;
  font-size: 15px;
  margin: 50px auto 0;
  height: 50px;
  border-radius: 10px;
}

.back-button:active {
  background: #a22631 !important;
}

/* 底部 */

footer {
  padding: 100px 0 30px 0;
  text-align: center;
  line-height: 30px;
  div {
    padding-top: 30px;
    margin: 0 auto;
    width: 80%;
    border-top: 1px dotted #5f5f5f;
    color: #a9a9a9;
    font-size: 8px;
  }
}

// 弹出层
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 200px;
  height: 200px;
  border-radius: 20px;
  overflow: hidden; // background-color: #fff;
}
</style>
